import { toast, type ToastOptions } from "vue3-toastify";

interface ToastContent {
  title?: string;
  description: string;
}

const createToastContent = ({ title, description }: ToastContent): string => {
  const titleHtml = title
    ? `<p class="mb-1"><span style="color: #B4B4C8; font-weight: 600;">${title}</span></p>`
    : "";
  return `${titleHtml}<p class="mb-0" style="font-size: 14px">${description}</p>`;
};

const defaultOptions: ToastOptions = {
  toastClassName: "custom-toast-warning",
};

const createToastWarning = (content: ToastContent, options: Partial<ToastOptions> = {}): void => {
  const mergedOptions = { ...defaultOptions, ...options };
  toast.warning(createToastContent(content), mergedOptions);
};

const createToastInfo = (content: ToastContent, options: Partial<ToastOptions> = {}): void => {
  const mergedOptions = { ...defaultOptions, ...options };
  toast.info(createToastContent(content), mergedOptions);
};

const createToastSuccess = (content: ToastContent, options: Partial<ToastOptions> = {}): void => {
  const mergedOptions = { ...defaultOptions, ...options };
  toast.success(createToastContent(content), mergedOptions);
};

export const showToast = {
  warning: createToastWarning,
  info: createToastInfo,
  success: createToastSuccess,
};
